import { Link } from 'react-router-dom';
import { MarketplaceCategory } from '../../lib/api';
import { cn } from '@/lib/utils';

interface CategoryNavProps {
  categories: MarketplaceCategory[];
  currentSlug?: string;
  currentCategoryId?: string;
  activeTab?: 'arches' | 'entities';
  layout?: 'horizontal' | 'vertical';
}

export function CategoryNav({
  categories,
  currentSlug,
  currentCategoryId,
  activeTab = 'arches',
  layout = 'horizontal',
}: CategoryNavProps) {
  // Group categories by parent
  const rootCategories = categories.filter((c) => c.parentCategoryId === null);

  const allLabel = activeTab === 'entities' ? 'All Entities' : 'All Arches';
  const isAllSelected = !currentSlug && !currentCategoryId;

  const getCategoryLink = (categoryId: string) => {
    return `/marketplace/browse?categoryId=${categoryId}&tab=${activeTab}`;
  };

  const isCategorySelected = (category: MarketplaceCategory) => {
    return currentCategoryId === category.categoryId || currentSlug === category.slug;
  };

  if (layout === 'vertical') {
    return (
      <nav className="space-y-1">
        <Link
          to={`/marketplace/browse?tab=${activeTab}`}
          className={cn(
            'block px-3 py-2 rounded-md text-sm transition-colors',
            isAllSelected
              ? 'bg-primary text-primary-foreground font-medium'
              : 'text-foreground hover:bg-accent'
          )}
        >
          {allLabel}
        </Link>
        {rootCategories.map((category) => (
          <Link
            key={category.categoryId}
            to={getCategoryLink(category.categoryId)}
            className={cn(
              'block px-3 py-2 rounded-md text-sm transition-colors',
              isCategorySelected(category)
                ? 'bg-primary text-primary-foreground font-medium'
                : 'text-foreground hover:bg-accent'
            )}
          >
            {category.name}
            <span className="ml-2 text-muted-foreground">({category.archeCount})</span>
          </Link>
        ))}
      </nav>
    );
  }

  return (
    <nav className="flex flex-wrap gap-2">
      <Link
        to={`/marketplace/browse?tab=${activeTab}`}
        className={cn(
          'px-4 py-2 rounded-full text-sm transition-colors',
          isAllSelected
            ? 'bg-primary text-primary-foreground'
            : 'bg-secondary text-secondary-foreground hover:bg-accent'
        )}
      >
        All
      </Link>
      {rootCategories.map((category) => (
        <Link
          key={category.categoryId}
          to={getCategoryLink(category.categoryId)}
          className={cn(
            'px-4 py-2 rounded-full text-sm transition-colors',
            isCategorySelected(category)
              ? 'bg-primary text-primary-foreground'
              : 'bg-secondary text-secondary-foreground hover:bg-accent'
          )}
        >
          {category.name}
        </Link>
      ))}
    </nav>
  );
}
